import styled from 'styled-components';
import { prop, theme } from 'styled-tools';
import sizes from 'themes/sizes';
import media from 'themes/media';

const Box = styled.div`
  ${sizes};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
  justify-content: ${(props) => (props.justify ? props.justify : 'initial')};
  flex-wrap: ${(props) => props.wrap || 'initial'};
  max-width: ${(props) => `${props.maxWidth}px` || 'initial'};
  display: ${(props) => (props.flex ? 'flex' : 'block')};
  width: ${(props) => props.width || 'auto'};
  flex: ${(props) => props.flexValue || 'unset'};

  .title {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 14px;
    color: ${theme('colors.text.white60')};
    ${media.lessThan('tablet')`
      font-size: 8px;
      line-height: 12px;
    `}
  }
  .wrap {
    background: #001947;
    border-radius: 20px;
  }
`;

export default Box;
